import React, {useContext, useImperativeHandle, useRef} from "react";
import {useATheme} from "@cisco-sbg-ui/magna-react";
import {isEmpty} from "lodash-es";
import {TimeBar} from "regraph";
import {useSelector} from "react-redux";
import {RelationsGraphContext} from "contexts/RelationsGraphContext";
import {selectInvestigationGraphLoading} from "store/selectors/investigationSelectors";
import {TIMEBAR_THEME_OPTIONS} from "utils/graph/graphStyleConstants";

const GraphTimebar = React.forwardRef((props, ref) => {
  const timebarRef = useRef();

  useImperativeHandle(
    ref,
    () => {
      return {
        reset() {
          timebarRef?.current && timebarRef.current.fit("all");
        }
      };
    },
    []
  );

  const {currentTheme} = useATheme();
  const isLoading = useSelector(selectInvestigationGraphLoading);

  const {timebarModel, handleTimebarChange} = useContext(RelationsGraphContext);

  return (
    <TimeBar
      ref={timebarRef}
      items={timebarModel}
      onChange={handleTimebarChange}
      style={{
        minHeight: "150px",
        width: "100%"
      }}
      options={
        currentTheme === "default"
          ? TIMEBAR_THEME_OPTIONS.LIGHT
          : TIMEBAR_THEME_OPTIONS.DARK
      }
      disabled={isLoading || isEmpty(timebarModel)}
    />
  );
});

export default GraphTimebar;
